import styled, { css } from "styled-components"
import { LayoutContainer } from "../grid"
import { mobileTextStyles, desktopTextStyles } from "../typography.styles"
import Breakpoints from "../breakpoints"
import Img from "gatsby-image"

export const OverlayStyle = css`
  background-color: var(--slate);

  @media (min-width: ${Breakpoints.md}) {
    background-color: transparent;
  }
`

export const Container = styled.div`
  & > ${LayoutContainer} {
    grid-template-rows: repeat(6, 1fr);
  }
`

export const PlatformBlocks = styled(Img)`
  display: none;
  @media (min-width: ${Breakpoints.md}) {
    z-index: 100;
    display: block;
    grid-column: 4 / -4;
    grid-row: 1 / 6;
    max-width: 100%;
    align-self: start;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -3;
  }
`

export const Title = styled.h2`
  ${mobileTextStyles.MobileHeadingTwoBold};
  color: var(--white);
  text-align: left;
  padding: 24px 20px;
  grid-column: 1 / -1;
  letter-spacing: 0.05em;
  z-index: 100;

  @media (min-width: ${Breakpoints.md}) {
    ${mobileTextStyles.MobileHeadingTwoSemiBold};
    color: var(--slate);
    text-align: center;
    grid-row: 5;
    padding: 0;

    & > span {
      font-weight: 500;
      display: block;
      color: var(--burnt-orange);
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingTwoRegular}
    grid-column: 2 / 7;
    grid-row: 2 / 5;
    text-align: left;
    & > span {
      display: inline;
    }
  }
`
